<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                                > Search Form 
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="px-2 pt-4 pb-0">
                                        <v-col lg="3" md="3" cols="12">
                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="From Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="from_date.value.value"
                                                :error-messages="from_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>
                                        </v-col>

                                        <v-col lg="3" md="3" cols="12">
                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="To Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="to_date.value.value"
                                                :error-messages="to_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>
                                        </v-col>


                                        <v-col lg="2" md="2" cols="12">
                                            <v-btn
                                                class="bg-brand w-15"
                                                type="submit"
                                                ref="searchButton"
                                                >Search</v-btn
                                            >
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>

        <v-container fluid style="margin-top: -20px;">
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                                >Sale Invoice List</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-row class="py-2">
                                    <v-col md="4" cols="12">
                                        <v-text-field
                                        v-model="search"
                                        append-inner-icon="mdi-magnify"
                                        label="Search"
                                        single-line
                                        hide-details
                                        density="compact"
                                        variant="outlined"
                                        bg-color="grey-lighten-4"
                                        class="pl-2"
                                        clearable
                                        ></v-text-field>
                                    </v-col>

                                    <v-col md="5" cols="12">
                                        <div class="d-flex align-center flex-column">
                                            <v-btn-group
                                                variant="outlined"
                                                density="compact"
                                                size="x-small"
                                                divided
                                            >
                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="success"
                                                @click="exportToCSV"
                                                >CSV</v-btn
                                                >
                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="primary"
                                                @click="exportToExcel"
                                                >EXCEL</v-btn
                                                >
                                                <v-btn
                                                prepend-icon="mdi mdi-download"
                                                variant="flat"
                                                color="red"
                                                @click="exportToPDF"
                                                >PDF</v-btn
                                                >
                                            </v-btn-group>
                                        </div>
                                    </v-col>

                                    <v-col md="3" cols="12">
                                        <!-- <div class="text-right">
                                            <v-btn
                                                v-if="$insertAccess($route.fullPath)"
                                                @click="goTo('/sales/add-sale-Invoice')"
                                                color="primary"
                                                variant="tonal"
                                                prepend-icon="mdi mdi-plus"
                                                rounded="xl"
                                            >
                                                Create Sale Invoice
                                            </v-btn>
                                        </div> -->
                                    </v-col>
                                </v-row>
                                <v-data-table
                                  :headers="headers"
                                  :items="getSchema"
                                  :loading="loading"
                                  v-model:items-per-page="itemsPerPage"
                                  :search="search"
                                  :hover="true"
                                  density="compact"
                                >
                                    <template v-slot:item.index="{ index }">
                                        {{ ++index }}
                                    </template>

                                    <template v-slot:item.customer="{ item }">
                                        {{ item.customer.company_name ? item.customer.company_name : item.customer.company_owner_name ? item.customer.company_owner_name : '' }}
                                    </template>

                                    <template v-slot:item.work_order="{ item }">
                                        {{ item.work_order?.code }}
                                    </template>

                                    <template v-slot:item.approved_ind="{ item }">
                                        <v-chip
                                        v-if="item.approved_ind == 1"
                                        color="success"
                                        size="small"
                                        class="text-capitalize"
                                        >Yes</v-chip
                                        >
                                        <v-chip
                                        v-else
                                        color="red"
                                        size="small"
                                        class="text-capitalize"
                                        >No</v-chip
                                        >
                                    </template>

                                    <template v-slot:item.approval_status_display="{ item }">
                                      <v-chip
                                        v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                                        color="yellow-darken-3"
                                        size="small"
                                      >
                                        Wating for {{ item.approval_current_process.approval_step_name.name }}
                                      </v-chip>

                                      <v-chip
                                        v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                                        color="green"
                                        size="small"
                                      >
                                        Approved By {{ item.approval_current_process.approval_step_name.name }}
                                      </v-chip>
                                      <v-chip
                                        v-else-if="item.approval_current_process && item.approval_current_process.status === 'Cancelled'"
                                        color="red"
                                        size="small"
                                      >
                                        Cancelled By  {{ item.approval_current_process.approval_step_name.name }}
                                      </v-chip>
                                      <v-chip
                                        v-else
                                        color="green"
                                        size="small"
                                      >
                                        {{ item.approval_status }}
                                      </v-chip>
                                    </template>
                                    
                                    <template v-slot:item.status="{ item }">
                                        <v-chip
                                        :color="statusMap[item.status]?.color || 'grey'"
                                        size="small"
                                        class="text-capitalize"
                                        >
                                        {{ statusMap[item.status]?.label || "Unknown" }}
                                        </v-chip>
                                    </template>

                                     <template v-slot:item.payment_status="{ item }">
                                        <v-chip
                                          v-if="item.due_amount == item.total"
                                          color="yellow"
                                          size="small"
                                          class="text-capitalize"
                                        >
                                        Not Paid
                                        </v-chip>


                                        <v-chip
                                          v-if="item.due_amount < item.total && item.due_amount > 0"
                                          color="primary"
                                          size="small"
                                          class="text-capitalize"
                                        >
                                          Partial Paid
                                        </v-chip>
                                        <v-chip
                                          v-if="item.due_amount <= 0"
                                          color="green"
                                          size="small"
                                          class="text-capitalize"
                                          >
                                          Paid
                                        </v-chip>
                                    </template>


                                    <template v-slot:item.actions="{ item }">
                                        <v-icon
                                              small
                                              @click="viewInvoice(item)"
                                              v-if="$updateAccess($route.fullPath) && item.status == '1'"
                                              class="me-2 edit-button"
                                              title="View Invoice"
                                              color="blue"
                                          >
                                            mdi-file-document-outline
                                        </v-icon>
                                        
                                        <v-icon
                                          class="me-2 edit-button"
                                          color="primary"
                                          @click="editItem(item)"
                                          v-if="$updateAccess($route.fullPath) && item.lock == '0' && canEdit(item)"
                                        >
                                          mdi mdi-pencil-outline
                                        </v-icon>

                                        <v-icon
                                          class="me-2 edit-button"
                                          color="primary"
                                          @click="poPayment(item)"
                                          v-if="$updateAccess($route.fullPath) && item.lock == '0' && item.due_amount <= item.total && item.due_amount > 0"
                                          title="PO Payment"
                                        >
                                          mdi-currency-usd
                                        </v-icon>
                                    </template>
                                </v-data-table>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
    <poPaymentSetup
      v-model:dialog="dialog"
      :data="data"
      @update:dialog="dialog = $event"
    />
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, nextTick } from "vue";
import { toast } from "vue3-toastify";
import { shallowRef } from "vue";
import formattedDate from "@/plugins/dateFormatter";
import statusMap from "@/utils/statusMap";
import poPaymentSetup from "@/components/module/sales/poPaymentSetup.vue";

export default {
        components: {
          poPaymentSetup,
        },
        data: () => ({
            itemsPerPage:10,
            panel: [0],
            loading:false,
            search: "",
            dialog: false,
            data:{},
            statusMap,
            headers: [
                { title: "#SL", align: "center", key: "index", width: "5%", sortable: false },
                { title: "Invoice No", key: "code",align: "center" , sortable: false },
                { title: "Order No", key: "sale_order.code",align: "center" , sortable: false },
                { title: "Ref No", key: "ref_no",align: "center" , sortable: false },
                { title: "Work Order", key: "work_order",align: "center" , sortable: false },
                { title: "Sale Invoice Date", key: "sale_invoice_date", align: "center" , sortable: false },
                { title: "Sale Order Date", key: "sale_order_date", align: "center" , sortable: false },
                { title: "Shipping Date", key: "shipping_date",align: "center" , sortable: false },
                { title: "Customer", key: "customer",align: "center" , sortable: false },
                { title: "Sub Total", key: "sub_total",align: "center" , sortable: false },
                { title: "Discount", key: "discount_amount", align: "center" , width: "60px", sortable: false },
                { title: "Vat", key: "vat_amount",align: "center" , width: "60px", sortable: false },
                { title: "Tax", key: "tax_amount",align: "center" , width: "60px", sortable: false },
                { title: "Total Amount",align: "center", key: "total", sortable: true },
                { title: "Paid", align: "center", key: "total_paid", sortable: true },
                { title: "Due", align: "center", key: "due_amount", sortable: true },
                { title: "Next Payment", key: "next_payment_date",align: "center" , sortable: false },
                { title: "Approval Status", align: "center", key: "approval_status_display", sortable: true },
                { title: "Status", align: "center", key: "status", sortable: true },
                { title: "Payment Status", align: "center", key: "payment_status", sortable: true },
                { title: "Actions", align: "center", key: "actions", width: "5%", sortable: false }
            ],
        }),
        watch: {
        },
        created(){
            // if(this.$store.getters.getProjectList.length === 0) {this.$store.dispatch('getProjectList');}
        },
        computed:{
            getSchema() {
                return this.$store.getters.getSaleInvoiceList;
            },
            getProjectList() {
                // return this.$store.getters.getProjectList;
                return [];
            },
        },
        setup() {
            const { handleSubmit, resetForm} = useForm({
                validationSchema: yup.object({
                    // from_date: yup.date().required().label('From Date'),
                    // to_date: yup.date().required().label('To Date'),
                }),
            });

    const customer_id = useField("customer_id");
    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();
    const submit = handleSubmit((values) => {
      loading.value = true;
      values.from_date = formattedDate(from_date.value.value);
      values.to_date = formattedDate(to_date.value.value);
      store
        .dispatch("getSaleInvoiceList", values)
        .then((response) => {
          loading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    return {
      submit,
      from_date,
      to_date,
      errorMessages,
      customer_id,
      loading,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    editItem(item) {
      // this.$store.commit('setEditingRfq', item);
      this.$router.push({
        name: "add-sale-invoice",
        query: { id: item.id },
      });
      // this.data = { ...item };
      // this.dialog = true;
    },
    canEdit(item){
      return (!item.approval_status || item.approval_status.toLowerCase() == 'pending' || item.status == 0)
    },
    poPayment(item) {
      this.data = { ...item };
      this.dialog = true;
    },
    // poPayment(item) {
    //   this.$router.push({
    //     name: "add-sale-invoice",
    //     query: { order_id: item.id }
    //   })
    // },
    viewInvoice(item) {
      this.$router.push({
        name: "view-sale-invoice",
        params: { id: item.id },
      });
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = [
        "#SL",
        "PR Code",
        "Warehouse",
        "Amount",
        "Approval Status",
        "PR Status",
      ];
      const rows = this.getSchema.map((item) => [
        serialNumber++,
        item.code,
        item.warehouse.name,
        item.amount,
        item.approved_ind === 1 ? "YES" : "NO",
        ,
        item.status == 1 ? "POST" : "DRAFT",
      ]);
      this.$exportTableToPDF(
        columns,
        rows,
        "Purchase Order List",
        "purchase_order_record_" + this.$fileDate(),
        "landscape"
      );
    },
    exportToExcel() {
      var data = [
        [
          "#SL",
          "PR Code",
          "Warehouse",
          "Amount",
          "Approval Status",
          "PR Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.warehouse.name,
          item.amount,
          item.approved_ind === 1 ? "YES" : "NO",
          ,
          item.status == 1 ? "POST" : "DRAFT",
        ]);
      });
      this.$exportTableToExcel(data, "purchase_order_record_" + this.$fileDate());
    },
    exportToCSV() {
      var data = [
        [
          "#SL",
          "PR Code",
          "Warehouse",
          "Amount",
          "Approval Status",
          "PR Status",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.code,
          item.warehouse.name,
          item.amount,
          item.approved_ind === 1 ? "YES" : "NO",
          ,
          item.status == 1 ? "POST" : "DRAFT",
        ]);
      });

      this.$exportTableToCSV(data, "purchase_order_record_" + this.$fileDate());
    },
  },
  mounted() {
    const today = new Date();
    const oneMonthBack = new Date();
    oneMonthBack.setMonth(today.getMonth() - 1);
    this.from_date.value.value = oneMonthBack;
    this.to_date.value.value = today;
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });
  },
};
</script>
